import * as React from "react";
import './NewsItem.scss';
import { useAuth } from "../../App";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { INewsItem } from '../../models/INews';
import { dateTimeToDateString } from '../../helpers/DateHelper'
import { NewsApi } from "../../api/NewsApi";
export const NewsItem: React.FunctionComponent<INewsItem> = ({ header, body, publishDate, links, attachments }) => {

    const auth = useAuth();
    const api = new NewsApi(auth);

    const renderLinks = () => {
        if (links?.length !== 0) {
            return <div className="col-6">
                <h6>Länkar</h6>
                <ul className="list-no-styling">
                    {
                        links?.map((link, index) =>
                            <li key={index}>
                                <a href={(link.url.includes("http://") || link.url.includes("https://")) ? link.url : "http://" + link.url}
                                    target="_blank">
                                    {link.description}
                                </a>
                            </li>
                        )
                    }
                </ul>
            </div>
        }
    }

    const renderDocuments = () => {
        if (attachments.length !== 0) {
            return <div className="col-6">
                <div className="row">
                    <h6 className="col-8">Filer</h6>
                    <h6 className="col-4">Ladda ner</h6>
                </div>
                <ul className="list-no-styling document-download-list">
                    {
                        attachments?.map((document, index) =>
                            <li key={index} className="row" onClick={() => downloadDocument(document.informationToCareProviderFileId, document.name)} title={`Ladda ner ${document.name}`}>
                                <div className="col-12 download">
                                    <div className="row">
                                        <p className="col-8">{document.name}</p>
                                        <span className="col-4"><FontAwesomeIcon icon={faDownload} /></span>
                                    </div>
                                </div>
                            </li>
                        )
                    }
                </ul>
            </div>
        }
    }

    const downloadDocument = (documentId: number, fileName?: string) => {
        api.downloadNewsAttachment(documentId, fileName,
            (error) => {
                alert(error);
            });
    }

    return (
        <div className="news-item__wrapper">
            <div className="card">
                <div className="card-body">
                    <h2>{header}</h2>
                    <i>{dateTimeToDateString(publishDate)}</i>
                    <div style={{ whiteSpace: "pre-wrap" }}>{body}</div>
                    <div className="row">
                        {renderLinks()}
                        {renderDocuments()}
                    </div>
                </div>
            </div>
        </div>
    )
}